module.exports = __webpack_public_path__ + "static/media/404-page.b829e5db.png";